import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { forOwn as _forOwn, get } from 'lodash-es';
import _ from 'lodash-es';
import ProductAddToCart from '../../dc-utils/ProductAddToCartDC';
import ProductExtraData from '../../utils/ProductExtraData';
import { ProductPriceString } from '../../dc-utils/ProductPriceString';
import SelectionDropDown from './SelectionDropDown';

const getCollapsedProducts = data => {
  const variants = [];
  let optionsArray = [];
  if (data.variants.length > 1) {
    const group = _.groupBy(data.variants, 'merchantProductSku');
    _forOwn(group, (collapsedVariants, key) => {
      variants.push(collapsedVariants[0]);
    });

    variants.forEach(variant => {
      optionsArray.push({
        id: variant.merchantProductSku,
        value: variant.variantTitle,
      });
    });
  }
  return { variants, optionsArray };
};

const Product = ({
  data,
  addButtonTitle,
  showAddtoCart,
  isReel,
  updateCategoryData,
  sourceMerchantProductSku,
  isAlreaydAdded,
  handleRemoveItem,
  setLoading,
}) => {
  const proddata = getCollapsedProducts(data);
  const [productData, setProductData] = useState(proddata);
  const [productVariantsDetails, setProductVariantDetails] = useState(data);
  const [variants, setVariants] = useState(productData.variants);
  const [variantOptions, setVariantOptions] = useState(
    productData.optionsArray
  );
  const [showDescription, SetShowDescription] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(data.variants[0]);
  const [currentVariant, setCurrentVariant] = useState(
    data.variants[0].merchantProductSku
  );

  useEffect(() => {
    // console.log(showAddtoCart);
    const prodData = getCollapsedProducts(data);
    setProductVariantDetails(prodData);
    setProductData(getCollapsedProducts(prodData));
    setVariants(prodData.variants);
    setVariantOptions(prodData.optionsArray);
    setCurrentProduct(data.variants[0]);
    setCurrentVariant(data.variants[0].merchantProductSku);
  }, [data]);

  const handleSelectVariantChange = event => {
    const id = event.target.value;
    const newVariant = variants.find(
      variant => variant.merchantProductSku === id
    );
    setCurrentProduct(newVariant);
    setCurrentVariant(newVariant.merchantProductSku);
  };

  const handleAdd = product => {
    updateCategoryData(product, 'Add');
  };

  let isSimpleProduct =
    productVariantsDetails.variants.length === 1 ? true : false;
  const newVar = currentVariant;
  let singleProduct = currentProduct;
  if (!isSimpleProduct) {
    let prod = variants.find(variant => variant.merchantProductSku === newVar);
    if (prod !== undefined) singleProduct = prod;
  }
  const optionsize = variantOptions.length;
  const IsOnSale =
    singleProduct &&
    singleProduct.price < singleProduct.compareAtPrice &&
    singleProduct.compareAtPrice != 0
      ? true
      : false;

  if (singleProduct) {
    if (showDescription == true) {
      window.$('.dcs-modal main').addClass('sortdescription');
    } else {
      window.$('.dcs-modal main').removeClass('sortdescription');
    }
    return (
      <div className="dc-product-container">
        <div className="mobile-products-name">
          <div className="product-options">
            {optionsize > 1 ? (
              <span
                style={{ color: 'grey', fontSize: '12px' }}
                className="xrs-product__compatible-options"
              >
                {' '}
                {optionsize} Options
              </span>
            ) : null}
          </div>
          <div className="dc-product-name">
            <span data-testid="productname">
              {!isSimpleProduct && optionsize != 0
                ? ReactHtmlParser(singleProduct.productName)
                : singleProduct.variantName.includes('Default Title')
                ? ReactHtmlParser(singleProduct.productName)
                : ReactHtmlParser(singleProduct.variantName)}
            </span>
          </div>
          {singleProduct.productDescription !== '' &&
          singleProduct.productDescription !== undefined ? (
            <label
              style={{ fontSize: '14px' }}
              onClick={() => SetShowDescription(!showDescription)}
            >
              {!showDescription ? 'View Description' : 'Hide Description'}
            </label>
          ) : null}
          {showDescription ? (
            <div className="dc-details-modal__desc">
              <span
                data-testid="productname"
                className="dc-details-modal__desc-mobile"
                onClick={() => SetShowDescription(!showDescription)}
              >
                <i className="arrow left"></i>
                <span className="mobile-content-comtainer">
                  {singleProduct.productName}
                </span>
              </span>
              <div className="wrapper-mobile">
                {ReactHtmlParser(singleProduct.productDescription)}
              </div>
            </div>
          ) : null}
        </div>
        <div className="dc-product-card--image">
          <div className="info">
            {IsOnSale ? <label className="sale">Sale</label> : null}
          </div>
          <a
            className="img-gallery"
            onClick={() => {
              window
                .$(
                  "<div id='imagesgaller' style='display:none;'><div class='img-gallery-center'><div class='gallery-wrap'><div class='gallery-wrap-center'><span class='close-gallery'>×</span>" +
                    '<img src=' +
                    singleProduct.url_image +
                    ' />' +
                    '</div></div></div></div>'
                )
                .appendTo('.dcs-modal');
              window.$('#imagesgaller').fadeIn();
              window.$('.close-gallery').click(function() {
                window.$('#imagesgaller').fadeOut(function() {
                  window.$(this).remove();
                });
              });
            }}
          >
            <img
              src={singleProduct.url_image}
              alt={ReactHtmlParser(singleProduct.variantName)}
              className="dc-product__image"
            />
          </a>
        </div>
        <div className="dc-product-card--name ">
          <div className="product-options">
            {optionsize > 1 ? (
              <span
                style={{ color: 'grey', olor: '#000000', fontSize: '12px' }}
                className="xrs-product__compatible-options"
              >
                {' '}
                {optionsize} Options
              </span>
            ) : null}
          </div>
          <div className="dc-product-name">
            <span data-testid="productname">
              {!isSimpleProduct && optionsize != 0
                ? ReactHtmlParser(singleProduct.productName)
                : singleProduct.variantName.includes('Default Title')
                ? ReactHtmlParser(singleProduct.productName)
                : ReactHtmlParser(singleProduct.variantName)}
            </span>
          </div>

          <div className="dc-select-wrapper" data-testid="product_selection">
            {!isSimpleProduct && optionsize != 0 ? (
              <SelectionDropDown
                singleProduct={singleProduct}
                variantOptions={variantOptions}
                handleSelectVariantChange={handleSelectVariantChange}
              />
            ) : null}
          </div>
          {singleProduct.productDescription !== '' &&
          singleProduct.productDescription !== undefined ? (
            <label
              style={{ fontSize: '14px' }}
              onClick={() => SetShowDescription(!showDescription)}
            >
              {!showDescription ? 'View Description' : 'Hide Description'}
            </label>
          ) : null}
          {showDescription ? (
            <div className="dc-details-modal__desc no-mobile">
              <div className="dc-details-modal__desc-wrapper">
                {ReactHtmlParser(singleProduct.productDescription)}
              </div>
            </div>
          ) : null}
        </div>
        <div className="dc-product-card--add-to-outfit">
          <div
            className="cardoutfit-section"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            <ProductPriceString
              price={singleProduct.price}
              compareAtPrice={singleProduct.compareAtPrice}
              currency={singleProduct.currency ? singleProduct.currency : 'USD'}
            />
            {singleProduct.extraData && (
              <ProductExtraData extraData={singleProduct.extraData} />
            )}

            {showAddtoCart ? (
              <ProductAddToCart
                _addButtonTitle={addButtonTitle}
                _singleProduct={singleProduct}
                _variantId={singleProduct.merchantProductSku}
                _baseItemId={sourceMerchantProductSku}
                handleAdd={handleAdd}
                isAlreaydAdded={isAlreaydAdded}
                setLoading={setLoading}
              />
            ) : (
              <a
                className="dc-outfit-button remove"
                onClick={() => {
                  handleRemoveItem(singleProduct);
                }}
              >
                Remove
              </a>
              // <input
              //   type="button"
              //   value={'Remove'}
              //   className="dc-outfit-button remove"
              //   onClick={() => {
              //     handleRemoveItem(singleProduct);
              //   }}
              // />
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
export default Product;
